// Query key factory for budget comments feature
export const budgetCommentsKeys = {
  // Base scope
  all: [{ scope: 'budgetComments' }] as const,
  // Comments queries
  comments: () => [{ ...budgetCommentsKeys.all[0], entity: 'comments' }] as const,
  commentsData: (params: { companyId: string; budgetingScenarioId?: number | null }) =>
    [
      {
        ...budgetCommentsKeys.comments()[0],
        companyId: params.companyId,
        budgetingScenarioId: params.budgetingScenarioId
      }
    ] as const
}
